import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {
  fetchData,
  fetchFormData,
  getTranslatedValue,
  hasSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  buildDropdownAudit,
} from '../../../../../../reusable'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import PhoneInput from 'react-phone-input-2'
import Select, { CSSObjectWithLabel } from 'react-select'
import {FileUploader} from 'react-drag-drop-files'
import {isEmptyArray} from 'formik'
import { Tr } from '../../../../../../_metronic/i18n/Tr'
import { useLang } from '../../../../../../_metronic/i18n/Metronici18n'

const VendorPersonalDetail: React.FC = () => {
  let t = Tr()

  let vendorId = sessionStorage.getItem("locationVendorId") || ''
  vendorId = atob(vendorId)
  const lang = useLang()


  const [loading, setLoading] = useState(false)
  const [vendorData, setVendorData] = useState(Object)

  //overview states
  const [imageUrl, setImageUrl] = useState('')
  const [profilePicture, setProfilePicture] = useState()
  const [fullName, setFullName] = useState('')
  const [countryCode, setCountryCode] = useState('uz')
  const [mobileNumber, setMobileNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
 

  const [error, setError] = useState([
    {
      profilePicture: '',
      fullName: '',
      businessName: '',
      mobileNumber: '',
      email: '',
      address: '',
      password: '',
      confirmPassword: '',
      categoryId: '',
    },
  ])
  const [categoryList, setCategoryList] = useState([])
  const [categorySelectedOptions, setCategorySelectedOptions] = useState<any>([])
  var categoryId = categorySelectedOptions.value
  const [profileEdit, setProfileEdit] = useState(false)

  // personal detail state
  const [propertyOwnerName, setpropertyOwnerName] = useState('')
  const [businessName, setBusinessName] = useState('')
  // const [region, setRegion] = useState('')
  const [addressLine2, setAddressLine2] = useState('')
  const [zipCode, setzipCode] = useState('')
  const [addressLine1, setAddressLine1] = useState('')
  const [personalEdit, setPersonalEdit] = useState(false)
  const [countryList, setCountryList] = useState([])
  const [countrySelectedOptions, setCountrySelectedOptions] = useState<any>()
  const [businessRegistration, setBusinessRegistration] = useState() as any
  const [businessRgst, setBusinessRgst] = useState('')
  const [referralCode, setReferralCode] = useState('')
  const [regionList, setRegionList] = useState([])
  const [regionSelectedOptions, setRegionSelectedOptions] = useState<any>([])
  

  // old dropdown states for audit labels
  const [oldCountry, setOldCountry] = useState<any>(null)
  const [oldRegion, setOldRegion] = useState<any>(null)

  // set error state
  const [personalDetailError, setPersonalDetailError] = useState([
    {
      ownerName: '',
      businessName: '',
      country: '',
      regionId: '',
      zipCode: '',
      addressLine1: '',
      businessRegistration: '',
    },
  ])

  // change password state
  const [newPassword, setNewPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [newPasswordDisplay, setNewPasswordDisplay] = useState(false)
  const [retypePasswordDisplay, setRetypePasswordDisplay] = useState(false)
  const [passwordError, setPasswordError] = useState(Object)

  useEffect(() => {
    if (!isEmptyArray(countryList) && !isEmptyArray(regionList)) {
      getprofile()
    }
  }, [countryList, regionList])

  const getprofile = async () => {
    var param: any = {
      vendorId: String(vendorId),
    }

    var response: any = await fetchData('vendor/public/viewProfile', param)

    if (response.status == '200') {
      var data = response.data[0]
           
      setpropertyOwnerName(data['propertyOwnerName'])
      setBusinessName(data['bussinessName'])
      setzipCode(data['zipcode'])
      setAddressLine1(data['addressline1'])
      setAddressLine2(data['addressline2'])
      setFullName(data['fullName'])
      setEmail(data['email'])
      setReferralCode(data['referralCode'])
      setMobileNumber(data['mobileNumber'])
      setCountryCode(data['countryCode'])
      var tmp: any = data['countryCode'] + data['mobileNumber']
      setPhoneNumber(tmp)

      setImageUrl(data['logo'])
      setBusinessRgst(data['businessDocument'])

      var tmp: any = countryList.filter((item: any) => item.value == data['countryId'])
      setCountrySelectedOptions(tmp.length > 0 ? tmp[0] : null)
      setOldCountry(tmp.length > 0 ? tmp[0] : null)

      var tmp3: any = regionList.filter((item: any) => String(item.value) == String(data['region']))

      setRegionSelectedOptions(tmp3)
      setOldRegion(tmp3.length > 0 ? tmp3[0] : null)

    } else {
      toasterrormsg(response.message)
    }
  }

  const regionListAPIcall = async () => {
    var res = await fetchData('vendor/public/regionList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.regionId, label:getTranslatedValue(lang, val, '_name')})
      })

      setRegionList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  // open approve conformation

  //profile detail function start

  //  category list api call
  const categoryAPIcall = async () => {
    var res = await fetchData('vendor/public/categoryList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.categoryId, label: val.en_name})
      })

      setCategoryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // set error state

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const handleChange = (value: any, country: any, e: any, formate: any) => {
    // log
    setPhoneNumber(value) // set mobile number default value
    removeError('phoneNumber') // remove error message
    const parts = formate.split(' ')
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
    setCountryCode(country.dialCode) // get country code
    setMobileNumber(formattedValue) // get mobile number without country code
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp: any = [...error]

    if (fullName.trim() === '' || fullName.trim() == null || fullName.trim() === undefined) {
      errorTmp[0].fullName = t("Full Name Is Required")
      isValid = false
    }

    if (
      mobileNumber.trim() === '' ||
      mobileNumber.trim() == null ||
      mobileNumber.trim() === undefined
    ) {
      errorTmp[0].mobileNumber = t("Mobile Number Is Required")
      isValid = false
    } else if (
      !mobileNumber.match(/^\d+$/) ||
      mobileNumber.length > 13 ||
      mobileNumber.length < 6
    ) {
      errorTmp[0].mobileNumber = t("Mobile Number Is Not Valid")
      isValid = false
    }
    if (email.trim() === '' || email.trim() == null || email.trim() === undefined) {
      errorTmp[0].email = t("Email Is Required")
      isValid = false
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t("Email Is Not Valid.")
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }

  // call update profile API
  const callupdateprofile = async () => {
    if (validate()) {
      setLoading(true)
      let param = new FormData()

      param.append('vendorId', String(vendorId))
      param.append('fullName', fullName)
      param.append('countryCode', countryCode)
      param.append('mobileNumber', mobileNumber)
      param.append('email', email)
      var admindata: any = sessionStorage.getItem('admin')
      admindata = JSON.parse(admindata)
      param.append('adminId', admindata['adminId'])
      if (profilePicture) {
        param.append('logo', profilePicture)
      }
      var res = await fetchFormData('vendor/public/updateProfile', param)
      if (res.status == '200') {
        setProfileEdit(false)
        toastsuccessmsg('Profile Updated Successfully')
        setLoading(false)
        getprofile()
      } else {
        setProfileEdit(false)
        setLoading(false)
        toasterrormsg(res.message)
      }
    }
  }
  const countryListAPIcall = async () => {
    var res = await fetchData('vendor/public/countryList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.countryId, label: val.nicename})
      })

      setCountryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation function
  const vendorPersonaldetailvalidate = () => {
    var isValid = true
    var errorTmp: any = [
      {
        ownerName: '',
        businessName: '',
        country: '',
        region: '',
        zipCode: '',
        addressLine1: '',
        businessRegistration: '',
      },
    ]
    let firstErrorField = null

    if (
      propertyOwnerName.trim() == '' ||
      propertyOwnerName.trim() == null ||
      propertyOwnerName.trim() == undefined
    ) {
      errorTmp[0].ownerName = t("Owner Name Is Required")
      isValid = false
      // if (!firstErrorField) firstErrorField = 'ownerName';
    } else if (!hasSpecialCharacters(propertyOwnerName.trim())) {
      errorTmp[0].ownerName = t("Special Characters Are Not Allowed")
      isValid = false
      if (!firstErrorField) firstErrorField = 'ownerName'
    }
    if (
      businessName.trim() == '' ||
      businessName.trim() == null ||
      businessName.trim() == undefined
    ) {
      errorTmp[0].businessName = t("Business Name Is Required")
      isValid = false
      if (!firstErrorField) firstErrorField = 'businessName'
    }
    if (
      countrySelectedOptions == '' ||
      countrySelectedOptions == null ||
      countrySelectedOptions == undefined ||
      countrySelectedOptions.value == undefined ||
      countrySelectedOptions.value == null ||
      countrySelectedOptions.value == ''
    ) {
      errorTmp[0].country = t("Country Is Required")
      isValid = false
      if (!firstErrorField) firstErrorField = 'country'
    }
    if (
      regionSelectedOptions == undefined ||
      regionSelectedOptions == '' ||
      regionSelectedOptions == null
    ) {
      errorTmp[0].regionId = t("Region Is Required")
      isValid = false
      if (!firstErrorField) firstErrorField = 'region'
    }
    if (
      addressLine1.trim() == '' ||
      addressLine1.trim() == null ||
      addressLine1.trim() == undefined
    ) {
      errorTmp[0].addressLine1 = t("Address Line1 Is Required")
      isValid = false
      if (!firstErrorField) firstErrorField = 'addressLine1'
    }
    if (zipCode.trim() == '' || zipCode.trim() == null || zipCode.trim() == undefined) {
      errorTmp[0].zipCode = t('Zip Code Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'zipCode'
    }
    if (!businessRgst || businessRgst.includes('default')) {
      if (
        businessRegistration == undefined ||
        businessRegistration == null ||
        businessRegistration == undefined
      ) {
        errorTmp[0].businessRegistration = t('Business Registration Document Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'businessRegistration'
      }
    }

    setPersonalDetailError(errorTmp)
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField)
      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'center'})
      }
    }
    return isValid
  }

  const fileTypes = ['JPEG', 'JPG', 'PNG', 'PDF']

  const handleBusinessRegistrationChange = (file: any) => {
    if (file) {
      if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg('Invalid file type. Please upload only image or pdf files.')
        setBusinessRegistration(undefined)

        return
      }
      // Handle business registration file change
      // For example:
      setBusinessRegistration(file)
      removeError('businessRegistration')
    } else {
  
    }
  }
  const handleDivClick = (inputId: string) => {
    const inputElement = document.getElementById(inputId)
    if (inputElement) {
      inputElement.click()
    }
  }
console.log(regionSelectedOptions);


  // add business details api call
  const addBusinessDetailsApi = async () => {
    if (vendorPersonaldetailvalidate()) {
      var admindata: any = sessionStorage.getItem('admin')
      admindata = JSON.parse(admindata)
      const regionData =  Array.isArray(regionSelectedOptions) ? regionSelectedOptions[0].value : typeof  regionSelectedOptions == "object"  ? regionSelectedOptions.value :"" 
      setLoading(true)
      let param = new FormData()
      param.append('vendorId', vendorId)
      param.append('propertyOwnerName', propertyOwnerName)
      param.append('bussinessName', businessName)
      param.append('country', countrySelectedOptions.value)
      param.append('region', regionData)
      param.append('addressline1', addressLine1)
      param.append('addressline2', addressLine2)
      param.append('zipcode', zipCode)
      param.append('adminId', admindata['adminId'])
      param.append('labels', buildDropdownAudit({
        country: { old: oldCountry, new: countrySelectedOptions },
        region: { old: oldRegion, new: regionSelectedOptions.length > 0 ? regionSelectedOptions[0] : regionSelectedOptions },
      }))

      if (businessRegistration) {
        param.append('businessDocument', businessRegistration)
      }
      var response: any = await fetchFormData('vendor/public/businessInformation', param)
      if (response.status == '200') {
        toastsuccessmsg('Business Information Saved Successfully!')
        const state = {
          vendorId: vendorId,
        }
        setPersonalEdit(false)
        setLoading(false)
      } else {
        setPersonalEdit(false)
        toasterrormsg(response.message)
        // setDisable(false)
        setLoading(false)
      }
    }
  }

  //////////////////////////////////////////////////// resert password function ////////////////////
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)
  const clearFields = () => {
    setNewPassword('')
    setRetypePassword('')
  }
  const [loading2, setLoading2] = useState(false)

  const validpassword = () => {
    var err = 0
    var tmp: any = {
      newPasswordError: '',
      retypePasswordError: '',
    }

    if (newPassword.trim() == '' || newPassword.trim() == null || newPassword.trim() == undefined) {
      tmp['newPasswordError'] = t('New Password Is Required')
      err = 1
    }

    if (
      retypePassword.trim() == '' ||
      retypePassword.trim() == null ||
      retypePassword.trim() == undefined
    ) {
      tmp['retypePasswordError'] = t('Confirm Password Required')
      err = 1
    } else if (newPassword != retypePassword) {
      toasterrormsg('New Password And Confirm Password Are Not Same')
      err = 1
    }
    setPasswordError(tmp)
    if (err == 0) {
      changepasswordapi()
    }
  }

  const changepasswordapi = async () => {
    var admindata: any = sessionStorage.getItem('admin')
    admindata = JSON.parse(admindata)
    var param: any = {
      vendorId: String(vendorId),
      adminId: admindata['adminId'],
      newPassword: newPassword,
    }

    var response: any = await fetchData('admin/resetvendorpassword', param)

    if (response.status == '200') {
      setPasswordForm(false)
      toastsuccessmsg(response.message)
    } else {
      toasterrormsg(response.message)
    }
  }
  // change password function end

  // action function end
  useEffect(() => {
    var vendor: any = sessionStorage.getItem('vendor')
    setVendorData(JSON.parse(vendor))
    categoryAPIcall()
    countryListAPIcall()
    regionListAPIcall()
  }, [])
  return (
    <>
      <ToastContainer />

      {/* profile detail  */}
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t("Profile Details")}</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show p-5'>
          <div className='w-100 text-right' style={{textAlign: 'right'}}>
            {!profileEdit && (
              <button
                className='btn btn-light btn-active-light-success me-10'
                onClick={() => {
                  setProfileEdit(true)
                }}
              >
                {t("Edit")}
              </button>
            )}
          </div>
          {/* <!--begin::Input group--> */}
          <div className='row mb-8'>
            {/* <!--begin::Col--> */}
            <div className='col-lg-12'>
              {/* <!--begin::Image input--> */}
              <div
                className='image-input image-input-outline '
                data-kt-image-input='true'
                id='profilePicture'
              >
                {/* <!--begin::Preview existing avatar--> */}

                <img
                  alt='images'
                  id='previewImage'
                  className='image-input-wrapper w-125px h-125px changeimg pointer'
                  src={
                    profilePicture
                      ? URL.createObjectURL(profilePicture)
                      : imageUrl === '' || imageUrl === null
                      ? toAbsoluteUrl('/media/avatars/300-1.jpg')
                      : imageUrl
                  }
                />

                {/* <!--end::Preview existing avatar--> */}
                {/* <!--begin::Label--> */}
                <label
                  className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                  data-kt-image-input-action='change'
                  data-bs-toggle='tooltip'
                  title=''
                  data-bs-original-title='Change avatar'
                >
                  <i className='fa fa-edit'></i>
                  {/* <!--begin::Inputs--> */}
                  <input
                    type='file'
                    disabled={!profileEdit}
                    name='image'
                    id='profileImage'
                    accept='.png, .jpg, .jpeg'
                    style={{display: 'none'}}
                    onChange={(e: any) => {
                      if (e.target.files[0] != null && e.target.files[0] != undefined) {
                        setProfilePicture(e.target.files[0])
                        removeError('profilePicture')
                      }
                    }}
                  />
                  <input type='hidden' name='avatar_remove' />
                  {/* <!--end::Inputs--> */}
                </label>
                {/* <!--end::Label--> */}
              </div>
              {/* <!--end::Image input--> */}
              {/* <!--begin::Hint--> */}
              <div className='form-text' id='validimage'>
                {t("Allowed file types: png, jpg, jpeg.")}
              </div>
              {/* <!--end::Hint--> */}
              <div className='text-danger fw-bold'>{error[0].profilePicture}</div>
            </div>
            {/* <!--end::Col--> */}
          </div>
          {/* <!--end::Input group--> */}
          {/* begin::Form group Firstname */}
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-dark fs-6 required'>{t("Full Name")}</label>
            <input
              placeholder={t("Full Name")}
              type='text'
              id='fullName'
              autoComplete='off'
              className='form-control bg-transparent'
              value={fullName}
              disabled={!profileEdit}
              onChange={(e: any) => {
                setFullName(e.target.value)
                removeError('fullName')
              }}
            />
            <div className='text-danger fw-bold'>{error[0].fullName}</div>
          </div>

          {/* end::Form group */}
          <div className='fv-row mb-8'>
            {/* begin::Form group Lastname */}
            <label className='form-label fw-bolder text-dark fs-6 required'>{t("Mobile Number")}</label>
            <div id='phoneNumber'>
              <PhoneInput
                inputClass='form-control form-control-solid w-100'
                placeholder={t('Enter Mobile Number')}
                enableSearch={true}
                value={phoneNumber}
                onChange={handleChange}
                disabled={!profileEdit}
              />
            </div>
            {/* end::Form group */}
            <div className='text-danger fw-bold'>{error[0].mobileNumber}</div>
          </div>

          {/* begin::Form group Email */}
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-dark fs-6 required'>{t("Email")}</label>
            <input
              placeholder={t('Enter Email')}
              type='email'
              id='email'
              autoComplete='off'
              className='form-control bg-transparent'
              value={email}
              onChange={(e: any) => {
                setEmail(e.target.value)
                removeError('email')
              }}
              disabled={!profileEdit}
            />
            <div className='text-danger fw-bold'>{error[0].email}</div>
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          {profileEdit && (
            <div className='text-center d-flex justify-content-center'>
              <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn btn-lg btn-primary mb-5 me-3'
                onClick={() => {
                  callupdateprofile()
                }}
              >
                <span className='indicator-label'>{t("Submit")}</span>
                {loading && (
                  <span className='indicator-progress'>
                    {t("Please wait...")}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>

              <button
                type='button'
                id='kt_login_signup_form_cancel_button'
                className='btn btn-lg btn-light-primary mb-5'
                onClick={() => {
                  setProfileEdit(false)
                  var tmp: any = [{email: '', mobileNumber: '', fullName: ''}]
                  setError(tmp)
                  getprofile()
                }}
              >
                {t("Cancel")}
              </button>
            </div>
          )}
          {/* end::Form group */}
        </div>
      </div>

      {/* personal detail  */}
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_personal_detail'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t("Personal Details")}</h3>
          </div>
        </div>

        <div id='kt_personal_detail' className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='d-flex flex-wrap align-items-center mb-10'>
              <div className='w-100 text-right' style={{textAlign: 'right'}}>
                {!personalEdit && (
                  <button
                    className='btn btn-light btn-active-light-success'
                    onClick={() => {
                      setPersonalEdit(true)
                    }}
                  >
                    {t("Edit")}
                  </button>
                )}
              </div>
              <div className='row'>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Owner Name")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <input
                      type='text'
                      placeholder={t("Owner Name")}
                      className='form-control bg-transparent'
                      disabled={!personalEdit}
                      value={propertyOwnerName || ' '}
                      onChange={(e: any) => {
                        setpropertyOwnerName(e.target.value)
                      }}
                    />
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['ownerName'] || ' '}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Business Name")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <input
                      type='text'
                      placeholder={t("Business Name")}
                      className='form-control bg-transparent'
                      disabled={!personalEdit}
                      value={businessName || ' '}
                      onChange={(e: any) => {
                        setBusinessName(e.target.value)
                      }}
                    />
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['businessName'] || ' '}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Country")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <Select
                      name='country'
                      id='country'
                      placeholder={t('Select Country')}
                      isSearchable={true}
                      options={countryList}
                      value={countrySelectedOptions}
                      isDisabled={!personalEdit}
                      onChange={(e: any) => {
                        setCountrySelectedOptions(e)
                        removeError('country')
                      }}
                    />
                    {/* <!--end::Input--> */}
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['country'] || ''}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Region")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <Select
                      name='selectRegion'
                      id='selectRegion'
                      placeholder={t('Select Region')}
                      isSearchable={true}
                      options={regionList}
                      isDisabled={!personalEdit}
                      value={regionSelectedOptions}
                      onChange={(e: any) => setRegionSelectedOptions(e)}
                      styles={{
                        container: (provided : CSSObjectWithLabel) => ({...provided, width: '100%'}),
                        control: (provided : CSSObjectWithLabel) => ({...provided, minHeight: 43}),
                      }}
                    />
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['regionId'] || ' '}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Address Line 1")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <input
                      type='text'
                      placeholder= {t("Address Line 1")}
                      className='form-control bg-transparent'
                      disabled={!personalEdit}
                      value={addressLine1 || ' '}
                      onChange={(e: any) => {
                        setAddressLine1(e.target.value)
                      }}
                    />
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['addressLine1'] || ' '}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center my-3'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Address Line 2")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <input
                      type='text'
                      className='form-control bg-transparent'
                      disabled={!personalEdit}
                      placeholder={t("Address Line 2")}
                      value={addressLine2 || ' '}
                      onChange={(e: any) => {
                        setAddressLine2(e.target.value)
                      }}
                    />
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Zip Code")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <input
                      type='text'
                      placeholder={t("Zip Code")}
                      className='form-control bg-transparent'
                      disabled={!personalEdit}
                      value={zipCode || ' '}
                      onChange={(e: any) => {
                        if (e.target.value.match(/^\d+$/) || e.target.value == '') {
                          setzipCode(e.target.value)
                        }
                      }}
                    />
                    <div className='text-danger fw-bold'>
                      {personalDetailError[0]['zipCode'] || ' '}
                    </div>
                  </div>
                </div>
                <div className='col-12 row d-flex align-items-center'>
                  <div className='col-xl-6 col-lg-6 fw-bold fs-6 text-gray-400'>{t("Referral Code")}</div>
                  <div className='col-xl-6 col-lg-6'>
                    <p className='fw-bold  text-muted  fs-5' > {referralCode ? referralCode : "No Referral Code Available" }</p>
                    
                  </div>
                </div>
                <div className='mt-5' id='businessRegistration'>
                  <div className='text-danger fw-bold'>
                    {personalDetailError[0].businessRegistration || ''}
                  </div>
                  <FileUploader
                    multiple={false}
                    handleChange={handleBusinessRegistrationChange}
                    name='businessRegistration'
                    types={fileTypes}
                    classes={personalEdit ? 'w-100' : 'w-100 cursor-default'}
                    disabled={!personalEdit}
                  >
                    <div
                      className={`dropzone border-success bg-light-success ${personalEdit ? 'dz-clickable' : ''}`}
                      id='kt_ecommerce_add_business_certificate'
                      style={!personalEdit ? { cursor: 'default' } : {}}
                      onClick={() => personalEdit && handleDivClick('businessRegistration')}
                    >
                      <div className='dz-message needsclick'>
                        {/* <!--begin::Icon--> */}
                        <i className='ki-outline ki-file-up text-success fs-3x'></i>
                        {/* <!--end::Icon--> */}
                        {/* <!--begin::Info--> */}
                        <div className='ms-4'>
                          <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                            {t("Upload Business Registration")}
                          </h3>
                          <span className='fs-7 fw-semibold text-gray-500'>
                            {t("Drag & Drop or choose files from computer")}
                          </span>
                        </div>
                        {/* <!--end::Info--> */}
                      </div>
                    </div>
                  </FileUploader>
                  {/* <!--begin::Message--> */}
                </div>
                {businessRegistration ? (
                  <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                    {businessRegistration && businessRegistration.type.startsWith('image/') ? (
                      <div
                        className='shadow-sm rounded-4'
                        style={{maxWidth: 'fit-content', width: '300px', height: '200px'}}
                      >
                        <a
                          rel='noreferrer'
                          href={URL.createObjectURL(businessRegistration)}
                          target='_blank'
                        >
                          <img
                            alt='images'
                            className='p-2 rounded-4'
                            src={URL.createObjectURL(businessRegistration)}
                            width='100%'
                            style={{width: '300px', height: '200px'}}
                          />
                        </a>
                      </div>
                    ) : (
                      <div className='card h-200px shadow-sm rounded-4 w-300px'>
                        <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                          <a
                            rel='noreferrer'
                            href={URL.createObjectURL(businessRegistration)}
                            target='_blank'
                            className='text-gray-800 text-hover-primary d-flex flex-column'
                          >
                            <div className='symbol symbol-75px mb-6'>
                              <img src={toAbsoluteUrl('/media/otherSVG/pdf.svg')} alt='pdf' />
                            </div>
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    {businessRgst ? (
                      <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                        {businessRgst && businessRgst.endsWith('.pdf') ? (
                          <div className='card h-200px shadow-sm rounded-4 w-300px'>
                            <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                              <a
                                rel='noreferrer'
                                href={businessRgst}
                                target='_blank'
                                className='text-gray-800 text-hover-primary d-flex flex-column'
                              >
                                <div className='symbol symbol-75px mb-6'>
                                  <img src={toAbsoluteUrl('/media/otherSVG/pdf.svg')} alt='pdf' />
                                </div>
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div
                            className='shadow-sm rounded-4'
                            style={{maxWidth: 'fit-content', width: '300px', height: '200px'}}
                          >
                            <a rel='noreferrer' href={businessRgst} target='_blank'>
                              <img
                                alt='images'
                                className='p-2 rounded-4'
                                src={businessRgst}
                                width='100%'
                                style={{width: '300px', height: '200px'}}
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                  </>
                )}

                {/* begin::Form group */}
                {personalEdit && (
                  <div className='text-center d-flex justify-content-center'>
                    <button
                      type='submit'
                      id='kt_sign_up_submit'
                      className='btn btn-lg btn-primary mb-5 me-3'
                      onClick={() => {
                        addBusinessDetailsApi()
                      }}
                    >
                      <span className='indicator-label'>{t("Submit")}</span>
                      {loading && (
                        <span className='indicator-progress'>
                          {t("Please wait...")}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>

                    <button
                      type='button'
                      id='kt_login_signup_form_cancel_button'
                      className='btn btn-lg btn-light-primary mb-5'
                      onClick={() => {
                        setPersonalEdit(false)
                        var tmp: any = [
                          {
                            ownerName: '',
                            businessName: '',
                            country: '',
                            region: '',
                            zipCode: '',
                            addressLine1: '',
                            businessRegistration: '',
                          },
                        ]
                        setPersonalDetailError(tmp)
                        getprofile()
                      }}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                )}
                {/* end::Form group */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* password cahnge  */}
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_signin_method'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t("Change Password")}</h3>
          </div>
        </div>

        <div id='kt_account_signin_method' className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='d-flex flex-wrap align-items-center mb-10'>
              <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
                <div className='fs-6 fw-bolder mb-1'>{t("Password")}</div>
                <div className='fw-bold text-gray-600'>************</div>
              </div>

              <div
                id='kt_signin_password_edit'
                className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
              >
                <div id='kt_signin_change_password' className='form'>
                  <div className='row mb-1'>
                    <div className='col-lg-4'>
                      <div className='fv-row mb-0'>
                        <label
                          htmlFor='newpassword'
                          className='form-label fs-6 fw-bolder mb-3 required'
                        >
                          {t("New Password")}
                        </label>
                        <div
                          className='fv-row fv-plugins-icon-container'
                          style={{position: 'relative'}}
                        >
                          <input
                            type={newPasswordDisplay == false ? 'password' : 'text'}
                            name='newPassword'
                            id='newPassword'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={t('New Password')}
                            value={newPassword}
                            onChange={(e: any) => setNewPassword(e.target.value)}
                          />
                          <span
                            className='cursor-pointer'
                            style={{position: 'absolute', top: '25%', right: '20px'}}
                            title={newPasswordDisplay == true ? 'Hide' : 'Show'}
                            onClick={() => setNewPasswordDisplay(!newPasswordDisplay)}
                          >
                            <FontAwesomeIcon
                              icon={newPasswordDisplay == true ? faEyeSlash : faEye}
                            />
                          </span>
                          {passwordError.newPasswordError && (
                            <div className='fv-plugins-message-container invalid-feedback text-danger fw-bold'>
                              {passwordError.newPasswordError || ''}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='fv-row mb-0'>
                        <label
                          htmlFor='confirmpassword'
                          className='form-label fs-6 fw-bolder mb-3 required'
                        >
                          {t("Confirm New Password")}
                        </label>
                        <div
                          className='fv-row fv-plugins-icon-container'
                          style={{position: 'relative'}}
                        >
                          <input
                            type={retypePasswordDisplay == false ? 'password' : 'text'}
                            name='confirmPassword'
                            id='confirmPassword'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={t('Confirm Password')}
                            value={retypePassword}
                            onChange={(e: any) => setRetypePassword(e.target.value)}
                          />
                          <span
                            className='cursor-pointer'
                            style={{position: 'absolute', top: '25%', right: '20px'}}
                            title={retypePasswordDisplay == true ? 'Hide' : 'Show'}
                            onClick={() => setRetypePasswordDisplay(!retypePasswordDisplay)}
                          >
                            <FontAwesomeIcon
                              icon={retypePasswordDisplay == true ? faEyeSlash : faEye}
                            />
                          </span>
                          {passwordError['retypePasswordError'] && (
                            <div className='fv-plugins-message-container invalid-feedback text-danger fw-bold'>
                              {passwordError['retypePasswordError'] || ''}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex mt-5'>
                    <button
                      id='kt_password_submit'
                      type='button'
                      className='btn btn-primary me-2 px-6'
                      onClick={() => validpassword()} 
                    >
                      {!loading2 && t('Update Password')}
                      {loading2 && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {t("Please wait...")}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setPasswordForm(false)
                        var tmp: any = {
                          newPasswordError: '',
                          retypePasswordError: '',
                        }
                        setPasswordError(tmp)
                      }}
                      id='kt_password_cancel'
                      type='button'
                      className='btn btn-color-gray-400 btn-active-light-primary px-6'
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </div>

              <div
                id='kt_signin_password_button'
                className={'ms-auto ' + (showPasswordForm && 'd-none')}
              >
                <button
                  onClick={() => {
                    setPasswordForm(true)
                    clearFields()
                  }}
                  className='btn btn-light btn-active-light-success'
                >
                  {t("Reset Password")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {VendorPersonalDetail}
